import type { Status } from "../adamo/types";

const mm = (v: number | null | undefined) => (v === null || v === undefined ? "—" : `${Math.round(v)} mm`);

export function StatusPanel({ status, stale }: { status: Status | null; stale: boolean }) {
  if (!status) return <p className="note">waiting for the robot to say something…</p>;
  const trip = status.trip.length ? `${status.trip[status.trip_index] ?? "done"} (${status.trip_index + 1}/${status.trip.length})` : null;
  return (
    <div className="rows">
      <Row k="state" v={`${status.state}${status.paused ? " · paused" : ""}${stale ? " · stale" : ""}`} />
      {trip && <Row k="on its way to" v={trip} />}
      <Row k="gripper" v={`${status.gripper_closed ? "closed" : "open"} · opens to ${mm(status.gripper_open_mm)}`} />
      <Row k="path" v={`start ${status.taught.start ? "set" : "unset"} · ${status.taught.waypoints} waypoint${status.taught.waypoints === 1 ? "" : "s"} · end ${status.taught.end ? "set" : "unset"}`} />
      <Row k="this session" v={`${status.cycle} pick${status.cycle === 1 ? "" : "s"}, ${status.trips} delivered, ${status.episodes} recorded`} />
      {status.highlight && (
        <Row k="fingers above the pile"
             v={status.highlight.low ? "low enough to pick" : mm(status.highlight.top_below_fingers_mm)} />
      )}
      {status.rim && (
        <Row k="camera vs the box"
             v={status.rim.level === "clear"
               ? (status.rim.voxels ? `clear · ${status.rim.voxels} voxels mapped` : "nothing mapped yet")
               : `${status.rim.level.toUpperCase()} · ${status.rim.say}`} />
      )}
      {status.message && <Row k="says" v={status.message} />}
    </div>
  );
}

function Row({ k, v }: { k: string; v: string }) {
  return <div className="row"><span className="k">{k}</span><span className="v">{v}</span></div>;
}
